import { isStringAndNotEmpty } from "../validation/is-string-and-not-empty";

export function capitalize(label: string): string {
    if (!isStringAndNotEmpty(label)) {
        return "";
    }
    return label.charAt(0).toUpperCase() + label.slice(1);
}
